import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { roleHomePath } from "@/lib/roles";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
    const navigate = useNavigate();
    const hasProcessed = useRef(false);
    const { setUser } = useAuth();

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        if (!sessionIdMatch) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(sessionIdMatch[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                setUser(data);
                // Clean hash
                window.history.replaceState(null, "", window.location.pathname);
                navigate(roleHomePath(data.role), { replace: true, state: { user: data } });
            } catch (error) {
                console.warn("[auth-callback] session exchange failed", error?.message);
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="flex items-center gap-3 text-muted-foreground">
                <Loader2 className="h-5 w-5 animate-spin" />
                <span>Signing you in…</span>
            </div>
        </div>
    );
}
